(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carrito-contenido"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delora-carrito')) {
    customElements.define(
      'delora-carrito',
      class DeloraCarrito extends HTMLElement {
        // Una sola petición de cambio a la vez en toda la página: Shopify aplica el cambio aunque el cliente aborte, y
        // una petición solapada usaría un índice de línea que la anterior ya movió
        static #peticion = null;

        #controlador;
        #temporizador = 0;
        #pendiente = null;
        #intenciones = [];
        #sustituyendo = false;

        connectedCallback() {
          this.#controlador?.abort();
          this.#controlador = new AbortController();
          const { signal } = this.#controlador;

          this.#ocultarSinJs();
          this.addEventListener('click', (evento) => this.#alPulsar(evento), { signal });
          this.addEventListener('input', (evento) => this.#alEscribir(evento), { signal });
          this.addEventListener('change', (evento) => this.#alCambiar(evento), { signal });
          this.addEventListener('keydown', (evento) => this.#alTeclear(evento), { signal });
          document.addEventListener('delora:carrito-actualizado', (evento) => this.#alActualizarOtro(evento), {
            signal,
          });
        }

        disconnectedCallback() {
          this.#controlador?.abort();
          if (DeloraCarrito.#peticion?.propietario === this) DeloraCarrito.#peticion.controlador.abort();
          clearTimeout(this.#temporizador);
          this.#pendiente = null;
        }

        #alPulsar(evento) {
          if (!(evento.target instanceof Element)) return;

          const paso = evento.target.closest('[data-accion]');
          if (paso && this.contains(paso)) {
            const linea = paso.closest('[data-linea]');
            const campo = linea?.querySelector('[data-cantidad]');
            if (!campo) return;

            const actual = Number.parseInt(campo.value, 10);
            const base = Number.isInteger(actual) ? actual : Number(campo.dataset.valor) || 0;
            campo.value = String(paso.dataset.accion === 'aumentar' ? base + 1 : Math.max(0, base - 1));
            this.#programar(linea);
            return;
          }

          const eliminar = evento.target.closest('[data-eliminar]');
          if (!eliminar || !this.contains(eliminar)) return;
          if (evento.defaultPrevented || evento.button !== 0) return;
          if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) return;

          const linea = eliminar.closest('[data-linea]');
          if (!linea) return;

          evento.preventDefault();
          const referencia = this.#referencia(linea);
          if (this.#pendiente && this.#mismaLinea(this.#pendiente, referencia)) this.#cancelarPendiente();
          else this.#ejecutarPendiente();

          const yaSeElimina = this.#intenciones.some(
            (intencion) => intencion.cantidad === 0 && this.#mismaLinea(intencion, referencia)
          );
          if (!yaSeElimina) this.#cambiar(referencia, 0);
        }

        #alEscribir(evento) {
          const campo = evento.target;
          if (this.#sustituyendo) return;
          if (!(campo instanceof HTMLInputElement) || !campo.matches('[data-cantidad]')) return;

          const linea = campo.closest('[data-linea]');
          if (linea) this.#programar(linea);
        }

        // La nota sí se guarda si su `change` llega mientras se sustituye el DOM: es el texto que el cliente escribió
        #alCambiar(evento) {
          const campo = evento.target;
          if (campo instanceof HTMLTextAreaElement && campo.matches('[data-nota]')) {
            this.#guardarNota(campo);
            return;
          }
          if (this.#sustituyendo) return;
          if (campo instanceof HTMLInputElement && campo.matches('[data-cantidad]')) this.#confirmar(campo);
        }

        // Al quitar un campo con foco, Chrome le dispara `change` antes de soltarlo; no es un cambio del cliente (su
        // intención ya está en la cola o pendiente) y con su `data-valor` viejo se enviaría otra vez
        #sustituir(accion) {
          this.#sustituyendo = true;
          try {
            accion();
          } finally {
            this.#sustituyendo = false;
          }
        }

        // Enter en una cantidad cambia en el acto; el envío implícito del formulario recargaría o iría al pago
        #alTeclear(evento) {
          const campo = evento.target;
          if (evento.key !== 'Enter' || evento.isComposing) return;
          if (!(campo instanceof HTMLInputElement) || !campo.matches('[data-cantidad]')) return;

          evento.preventDefault();
          this.#confirmar(campo);
          this.#ejecutarPendiente();
        }

        #alActualizarOtro(evento) {
          const { origen, secciones } = evento.detail ?? {};
          const html = secciones?.[this.dataset.seccion];
          if (origen === this.dataset.seccion || !html) return;

          this.#pintar(html);
        }

        #cantidadValida(campo) {
          const texto = campo.value.trim();
          const cantidad = Number(texto);
          if (texto === '' || !Number.isInteger(cantidad) || cantidad < 0) return null;
          return cantidad;
        }

        // Cantidad que la línea tendrá cuando termine la cola: la última encolada o la del servidor
        #vigente(referencia, campo) {
          const encolada = this.#intenciones.findLast((intencion) => this.#mismaLinea(intencion, referencia));
          return encolada ? encolada.cantidad : Number(campo.dataset.valor);
        }

        #confirmar(campo) {
          const linea = campo.closest('[data-linea]');
          if (!linea) return;
          if (this.#cantidadValida(campo) !== null) {
            this.#programar(linea);
            return;
          }

          const referencia = this.#referencia(linea);
          campo.value = String(this.#vigente(referencia, campo));
          if (this.#pendiente && this.#mismaLinea(this.#pendiente, referencia)) this.#cancelarPendiente();
        }

        #programar(linea) {
          const campo = linea.querySelector('[data-cantidad]');
          if (!campo) return;

          const referencia = this.#referencia(linea);
          const mismaPendiente = this.#pendiente !== null && this.#mismaLinea(this.#pendiente, referencia);
          if (this.#pendiente && !mismaPendiente) this.#ejecutarPendiente();

          const cantidad = this.#cantidadValida(campo);
          if (cantidad === null || cantidad === this.#vigente(referencia, campo)) {
            if (mismaPendiente) this.#cancelarPendiente();
            return;
          }

          clearTimeout(this.#temporizador);
          this.#pendiente = { ...referencia, cantidad };
          this.#temporizador = setTimeout(() => this.#ejecutarPendiente(), 300);
        }

        #ejecutarPendiente() {
          clearTimeout(this.#temporizador);
          const pendiente = this.#pendiente;
          this.#pendiente = null;
          if (pendiente) this.#cambiar(pendiente, pendiente.cantidad);
        }

        #cancelarPendiente() {
          clearTimeout(this.#temporizador);
          this.#pendiente = null;
        }

        #lineas() {
          return [...this.querySelectorAll('[data-linea]')];
        }

        // Una línea se identifica por su clave y su orden entre las líneas con la misma clave: el índice cambia al eliminar
        #referencia(linea) {
          const lineas = this.#lineas();
          const clave = linea.dataset.clave ?? '';
          const ordinal = lineas.filter((otra) => otra.dataset.clave === clave).indexOf(linea);
          return { clave, ordinal, posicion: lineas.indexOf(linea) };
        }

        #mismaLinea(a, b) {
          return a.clave === b.clave && a.ordinal === b.ordinal;
        }

        #buscarLinea({ clave, ordinal }) {
          return this.#lineas().filter((linea) => linea.dataset.clave === clave)[ordinal] ?? null;
        }

        #quitarIntencion(intencion) {
          const indice = this.#intenciones.indexOf(intencion);
          if (indice !== -1) this.#intenciones.splice(indice, 1);
        }

        #idCabecera() {
          return document
            .querySelector('[data-carrito-cabecera]')
            ?.closest('.shopify-section')
            ?.id.replace(/^shopify-section-/, '');
        }

        #ids() {
          const ids = new Set([this.dataset.seccion]);
          for (const carrito of document.querySelectorAll('delora-carrito[data-seccion]')) {
            ids.add(carrito.dataset.seccion);
          }
          const cabecera = this.#idCabecera();
          const lista = [...ids].filter(Boolean).slice(0, cabecera ? 4 : 5);
          if (cabecera) lista.push(cabecera);
          return lista;
        }

        // Espera su turno, busca la línea en el DOM ya repintado por la petición anterior y, si sigue ahí, la cambia
        async #cambiar(referencia, cantidad) {
          const intencion = { clave: referencia.clave, ordinal: referencia.ordinal, cantidad };
          this.#intenciones.push(intencion);
          this.setAttribute('aria-busy', 'true');

          try {
            while (DeloraCarrito.#peticion) {
              await DeloraCarrito.#peticion.hecha;
              if (!this.isConnected) return;
            }

            const linea = this.#buscarLinea(intencion);
            if (!linea) return;

            const controlador = new AbortController();
            let terminar = () => {};
            const hecha = new Promise((resolver) => {
              terminar = resolver;
            });
            DeloraCarrito.#peticion = { propietario: this, controlador, hecha };

            try {
              await this.#enviar(intencion, Number(linea.dataset.linea), controlador.signal);
            } finally {
              DeloraCarrito.#peticion = null;
              terminar();
            }
          } finally {
            this.#quitarIntencion(intencion);
            if (this.#intenciones.length === 0) this.removeAttribute('aria-busy');
          }
        }

        // Límite de 15 s: una petición colgada bloquearía la cola. Sin `AbortSignal.any` (Safari < 17.4), a mano: el
        // temporizador se limpia al terminar (`liberar`) o al abortar, y una señal ya abortada se propaga en el acto
        #conLimite(signal) {
          const milisegundos = 15000;
          if (typeof AbortSignal.any === 'function' && typeof AbortSignal.timeout === 'function') {
            return { signal: AbortSignal.any([signal, AbortSignal.timeout(milisegundos)]), liberar: () => {} };
          }

          const controlador = new AbortController();
          if (signal.aborted) {
            controlador.abort(signal.reason);
            return { signal: controlador.signal, liberar: () => {} };
          }

          let temporizador = 0;
          const alAbortar = () => {
            clearTimeout(temporizador);
            controlador.abort(signal.reason);
          };
          const liberar = () => {
            clearTimeout(temporizador);
            signal.removeEventListener('abort', alAbortar);
          };
          signal.addEventListener('abort', alAbortar, { once: true });
          temporizador = setTimeout(() => {
            signal.removeEventListener('abort', alAbortar);
            controlador.abort(new DOMException('Tiempo agotado', 'TimeoutError'));
          }, milisegundos);
          return { signal: controlador.signal, liberar };
        }

        // Shopify puede aplicar un cambio aunque responda con error (422 al rebajar al stock) o no llegue la respuesta,
        // así que tras cualquier fallo se lee su estado; solo si esa lectura también falla se restaura el valor
        async #enviar(intencion, linea, signal) {
          this.#mostrarError('');
          let json = {};
          let error = '';
          let deRed = false;

          const limite = this.#conLimite(signal);
          try {
            const respuesta = await fetch(`${this.dataset.urlCambio}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                line: linea,
                quantity: intencion.cantidad,
                sections: this.#ids().join(','),
                sections_url: window.location.pathname,
              }),
              signal: limite.signal,
            });
            json = await respuesta.json().catch(() => ({}));
            limite.signal.throwIfAborted();
            if (!respuesta.ok) error = json.description || json.message || this.dataset.textoError || '';
          } catch (fallo) {
            if (signal.aborted) return;
            console.error(fallo);
            deRed = true;
            error = this.dataset.textoError ?? '';
          } finally {
            limite.liberar();
          }

          const aplicado = !error && Number.isInteger(json.item_count);
          if (aplicado && json.sections?.[this.dataset.seccion]) {
            this.#aplicar(intencion, json.sections, json.item_count);
            return;
          }

          // El mensaje de Shopify (p. ej. el 422 del stock) se muestra ya y se queda. El genérico de red o de tiempo
          // espera a la resincronización: si confirma el cambio no se muestra (ni se anuncia en falso con role="alert")
          if (error && !deRed) this.#mostrarError(error);
          const [secciones, cantidad] = await Promise.all([
            this.#resincronizar(signal),
            aplicado ? json.item_count : this.#contar(signal),
          ]);
          if (signal.aborted) return;
          if (secciones && cantidad !== null) {
            this.#aplicar(intencion, secciones, cantidad);
            if (deRed && !this.#confirmado(intencion)) this.#mostrarError(error);
            return;
          }

          this.#quitarIntencion(intencion);
          if (!aplicado) {
            if (deRed) this.#mostrarError(error);
            this.#restaurar(intencion);
            return;
          }
          this.#aplicarSinHtml(intencion, json);
          this.#sustituirCabecera(json.sections);
          this.#anunciar(json.item_count);
          this.#emitir(json.sections ?? {}, json.item_count);
        }

        // La intención sale de la cola justo antes de repintar, para que `#vigente` no vea un `data-valor` viejo
        #aplicar(intencion, secciones, cantidad) {
          this.#quitarIntencion(intencion);
          this.#pintar(secciones[this.dataset.seccion]);
          this.#sustituirCabecera(secciones);
          this.#anunciar(cantidad);
          this.#emitir(secciones, cantidad);
        }

        // Con el DOM ya resincronizado: la línea tiene la cantidad pedida (`data-valor` viene del servidor) o, si se pidió
        // 0, ya no está
        #confirmado(intencion) {
          const linea = this.#buscarLinea(intencion);
          if (intencion.cantidad === 0) return linea === null;
          return Number(linea?.querySelector('[data-cantidad]')?.dataset.valor) === intencion.cantidad;
        }

        #emitir(secciones, cantidad) {
          document.dispatchEvent(
            new CustomEvent('delora:carrito-actualizado', {
              detail: { secciones, origen: this.dataset.seccion, abrir: false, anuncio: null, cantidad },
            })
          );
        }

        // HTML actual de las mismas secciones que pide el cambio (instancias y cabecera), con la Section Rendering API.
        // Sin `Accept: application/json`: con esa cabecera, `/cart?sections=` devuelve el JSON del carrito
        async #resincronizar(signal) {
          const limite = this.#conLimite(signal);
          try {
            const url = new URL(window.location.pathname, window.location.origin);
            url.searchParams.set('sections', this.#ids().join(','));
            const respuesta = await fetch(url, { signal: limite.signal });
            if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`);
            const secciones = await respuesta.json();
            if (!secciones?.[this.dataset.seccion]) throw new Error('La resincronización no trae el HTML del carrito');
            return secciones;
          } catch (fallo) {
            if (!signal.aborted) console.error(fallo);
            return null;
          } finally {
            limite.liberar();
          }
        }

        async #contar(signal) {
          const limite = this.#conLimite(signal);
          try {
            const respuesta = await fetch(`${this.dataset.urlCarrito}.js`, {
              headers: { Accept: 'application/json' },
              signal: limite.signal,
            });
            if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`);
            const { item_count: cantidad } = await respuesta.json();
            return Number.isInteger(cantidad) ? cantidad : null;
          } catch (fallo) {
            if (!signal.aborted) console.error(fallo);
            return null;
          } finally {
            limite.liberar();
          }
        }

        #cantidadDevuelta(intencion, json) {
          if (!Array.isArray(json.items)) return undefined;
          return json.items.filter((item) => item.key === intencion.clave)[intencion.ordinal]?.quantity;
        }

        // Shopify aplicó el cambio pero no hay HTML nuevo: se deja la cantidad aplicada y se quita la línea eliminada
        #aplicarSinHtml(intencion, json) {
          const linea = this.#buscarLinea(intencion);
          if (!linea) return;

          const foco = this.#recordarFoco();
          const cantidad = intencion.cantidad === 0 ? 0 : (this.#cantidadDevuelta(intencion, json) ?? intencion.cantidad);
          if (cantidad === 0) {
            this.#sustituir(() => linea.remove());
            for (const [indice, otra] of this.#lineas().entries()) otra.dataset.linea = String(indice + 1);
          } else {
            const campo = linea.querySelector('[data-cantidad]');
            if (campo) {
              campo.value = String(cantidad);
              campo.dataset.valor = String(cantidad);
            }
          }
          this.#restaurarFoco(foco);
        }

        async #guardarNota(campo) {
          try {
            const respuesta = await fetch(`${this.dataset.urlActualizar}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ note: campo.value }),
              signal: this.#controlador?.signal,
            });
            if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`);
          } catch (error) {
            if (error?.name === 'AbortError') return;
            console.error(error);
            this.#mostrarError(this.dataset.textoError ?? '');
          }
        }

        #restaurar(intencion) {
          const campo = this.#buscarLinea(intencion)?.querySelector('[data-cantidad]');
          if (campo) campo.value = String(this.#vigente(intencion, campo));
        }

        // Conserva las regiones vivas: una región que se inserta ya con texto no siempre se anuncia
        #pintar(html) {
          const documento = new DOMParser().parseFromString(html, 'text/html');
          const nuevo =
            documento.querySelector(`delora-carrito[data-seccion="${CSS.escape(this.dataset.seccion ?? '')}"]`) ??
            documento.querySelector('delora-carrito');
          if (!nuevo) return;

          const foco = this.#recordarFoco();
          const nota = this.querySelector('[data-nota]')?.value;
          const vivas = [...this.querySelectorAll(':scope > [data-estado], :scope > [data-error]')];

          this.#sustituir(() => {
            for (const hijo of [...this.childNodes]) {
              if (!vivas.includes(hijo)) hijo.remove();
            }
            for (const nodo of [...nuevo.childNodes]) {
              if (nodo instanceof Element && nodo.matches('[data-estado], [data-error]')) continue;
              this.insertBefore(document.importNode(nodo, true), vivas[0] ?? null);
            }
          });

          const campoNota = this.querySelector('[data-nota]');
          if (campoNota && nota !== undefined) campoNota.value = nota;
          for (const intencion of [...this.#intenciones, this.#pendiente]) {
            if (!intencion) continue;
            const campo = this.#buscarLinea(intencion)?.querySelector('[data-cantidad]');
            if (campo) campo.value = String(intencion.cantidad);
          }

          this.#ocultarSinJs();
          this.#restaurarFoco(foco);
        }

        #selectorDe(elemento) {
          for (const atributo of ['data-accion', 'data-cantidad', 'data-eliminar', 'data-nota', 'data-explorar']) {
            if (!elemento.hasAttribute(atributo)) continue;
            const valor = elemento.getAttribute(atributo);
            return valor ? `[${atributo}="${CSS.escape(valor)}"]` : `[${atributo}]`;
          }
          const nombre = elemento.getAttribute('name');
          if (nombre) return `[name="${CSS.escape(nombre)}"]`;
          if (elemento.classList.length === 0) return null;
          return `${[...elemento.classList].map((clase) => `.${CSS.escape(clase)}`).join('')}:not([hidden])`;
        }

        #recordarFoco() {
          const activo = document.activeElement;
          if (!(activo instanceof HTMLElement) || !this.contains(activo)) return null;

          const foco = { selector: this.#selectorDe(activo) };
          if (activo instanceof HTMLTextAreaElement) {
            foco.seleccion = [activo.selectionStart, activo.selectionEnd];
          }
          const linea = activo.closest('[data-linea]');
          return linea ? { ...foco, ...this.#referencia(linea) } : foco;
        }

        #restaurarFoco(foco) {
          if (!foco) return;

          let destino = null;
          if (foco.clave === undefined) {
            destino = foco.selector ? this.querySelector(foco.selector) : null;
          } else {
            const linea = this.#buscarLinea(foco);
            if (linea) {
              destino = foco.selector ? linea.querySelector(foco.selector) : null;
            } else {
              const lineas = this.#lineas();
              const vecina = lineas[foco.posicion] ?? lineas[foco.posicion - 1];
              destino = vecina?.querySelector('[data-cantidad]') ?? null;
            }
          }
          destino ??= this.querySelector('[data-explorar]') ?? this.querySelector('[data-cantidad]');
          if (!(destino instanceof HTMLElement) || destino === document.activeElement) return;

          destino.focus();
          if (destino instanceof HTMLTextAreaElement && foco.seleccion) {
            destino.setSelectionRange(...foco.seleccion);
          }
        }

        #sustituirCabecera(secciones) {
          const id = this.#idCabecera();
          const html = id ? secciones?.[id] : null;
          const actual = document.querySelector('a[data-carrito-cabecera]');
          if (!html || !actual) return;

          const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('a[data-carrito-cabecera]');
          if (!nuevo) return;

          const enfocado = document.activeElement === actual;
          const importado = document.importNode(nuevo, true);
          actual.replaceWith(importado);
          if (enfocado) importado.focus();
        }

        #anunciar(cantidad) {
          const estado = this.querySelector('[data-estado]');
          if (!estado) return;

          let texto = (this.dataset.textoVarios ?? '').replace('[cantidad]', String(cantidad));
          if (cantidad === 0) texto = this.dataset.textoVacio ?? '';
          if (cantidad === 1) texto = this.dataset.textoUno ?? '';
          estado.textContent = estado.textContent === texto ? `${texto} ` : texto;
        }

        #mostrarError(texto) {
          const error = this.querySelector('[data-error]');
          if (error) error.textContent = texto;
        }

        #ocultarSinJs() {
          for (const elemento of this.querySelectorAll('[data-sin-js]')) elemento.hidden = true;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filtros-coleccion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delora-filtros')) {
    customElements.define(
      'delora-filtros',
      class DeloraFiltros extends HTMLElement {
        static #secciones = new WeakMap();

        #controlador;
        #peticion;
        #espera;
        #raiz = document;
        #idSeccion = '';
        #cambiosEnCajon = false;

        connectedCallback() {
          this.#controlador?.abort();
          this.#controlador = new AbortController();
          const { signal } = this.#controlador;

          const seccion = this.closest('.shopify-section');
          this.#raiz = seccion ?? document;
          this.#idSeccion = seccion?.id.replace(/^shopify-section-/, '') ?? '';

          this.addEventListener('change', (evento) => this.#alCambiar(evento), { signal });
          this.addEventListener('submit', (evento) => this.#alEnviar(evento), { signal });
          this.addEventListener('click', (evento) => this.#alPulsar(evento), { signal });
          this.addEventListener('toggle', (evento) => this.#alAlternar(evento), { capture: true, signal });
        }

        disconnectedCallback() {
          this.#controlador?.abort();
          this.#peticion?.abort();
          clearTimeout(this.#espera);
        }

        #estadoSeccion() {
          let estado = DeloraFiltros.#secciones.get(this.#raiz);
          if (!estado) {
            estado = { peticion: null, espera: 0 };
            DeloraFiltros.#secciones.set(this.#raiz, estado);
          }
          return estado;
        }

        #alCambiar(evento) {
          if (!(evento.target instanceof Element)) return;
          const formulario = evento.target.closest('form[data-delora-filtros]');
          if (!formulario) return;

          if (evento.target instanceof HTMLInputElement && evento.target.type === 'number') {
            const estado = this.#estadoSeccion();
            clearTimeout(estado.espera);
            estado.peticion?.abort();
            estado.espera = setTimeout(() => this.#actualizar(this.#urlFormulario(formulario)), 500);
            this.#espera = estado.espera;
            return;
          }

          this.#actualizar(this.#urlFormulario(formulario));
        }

        #alEnviar(evento) {
          const formulario = evento.target;
          if (!(formulario instanceof HTMLFormElement) || !formulario.matches('[data-delora-filtros]')) return;

          evento.preventDefault();
          this.#actualizar(this.#urlFormulario(formulario));
        }

        #alPulsar(evento) {
          if (evento.defaultPrevented || evento.button !== 0) return;
          if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) return;
          if (!(evento.target instanceof Element)) return;

          const enlace = evento.target.closest('a[data-delora-enlace]');
          if (!enlace || !this.contains(enlace)) return;

          evento.preventDefault();
          this.#actualizar(enlace.href);
        }

        #alAlternar(evento) {
          const cajon = evento.target;
          if (!(cajon instanceof HTMLElement) || !cajon.matches('[data-delora-cajon]')) return;

          if (evento.newState === 'open') {
            this.#cambiosEnCajon = false;
            cajon.querySelector('[data-delora-cerrar]')?.focus();
            return;
          }

          const actual = document.activeElement;
          if (!actual || actual === document.body || cajon.contains(actual)) {
            this.querySelector('[data-delora-abrir]')?.focus();
          }

          if (!this.#cambiosEnCajon) return;
          this.#cambiosEnCajon = false;

          const resultados = this.#regiones('resultados')[0];
          const barra = this.querySelector('[data-delora-barra]');
          if (!resultados || !barra) return;

          const desfase = resultados.getBoundingClientRect().top - barra.getBoundingClientRect().bottom;
          if (desfase < 0) window.scrollBy({ top: desfase });
        }

        #abierto(cajon) {
          return 'popover' in cajon && cajon.matches(':popover-open');
        }

        #urlFormulario(formulario) {
          const url = new URL(formulario.action, window.location.href);
          const parametros = new URLSearchParams();
          for (const [nombre, valor] of new FormData(formulario)) {
            if (typeof valor === 'string' && valor.trim() !== '') parametros.append(nombre, valor);
          }

          url.search = parametros.toString();
          url.hash = '';
          return url;
        }

        async #actualizar(destino) {
          const estado = this.#estadoSeccion();
          clearTimeout(estado.espera);
          estado.peticion?.abort();

          const url = new URL(destino, window.location.href);
          url.searchParams.delete('section_id');

          if (!this.#idSeccion) {
            window.location.assign(url.href);
            return;
          }

          const peticion = new AbortController();
          estado.peticion = peticion;
          this.#peticion = peticion;

          const pedido = new URL(url);
          pedido.searchParams.set('section_id', this.#idSeccion);
          this.#marcarOcupado(true);

          try {
            const respuesta = await fetch(pedido, { signal: peticion.signal });
            if (!respuesta.ok) throw new Error(`HTTP ${respuesta.status}`);

            const html = await respuesta.text();
            if (peticion.signal.aborted) return;

            const documento = new DOMParser().parseFromString(html, 'text/html');
            const enfocado = document.activeElement;
            const foco = this.#recordarFoco(enfocado);
            const cajon = enfocado?.closest('[data-delora-cajon]');
            const respaldo = cajon && this.#abierto(cajon) ? cajon.querySelector('[data-delora-ver-resultados]') : null;

            this.#sustituirRegiones(documento);
            this.#sincronizarFormularios(documento);
            this.#anunciar();
            window.history.replaceState(null, '', url.href);
            this.#restaurarFoco(enfocado, foco, respaldo);

            for (const abierto of this.querySelectorAll('[data-delora-cajon]')) {
              if (this.#abierto(abierto)) this.#cambiosEnCajon = true;
            }
          } catch (error) {
            if (peticion.signal.aborted || error?.name === 'AbortError') return;
            window.location.assign(url.href);
          } finally {
            if (estado.peticion === peticion) {
              estado.peticion = null;
              this.#marcarOcupado(false);
            }
          }
        }

        #regiones(nombre) {
          return [...this.#raiz.querySelectorAll('[data-delora-region]')].filter(
            (region) => region.getAttribute('data-delora-region') === nombre
          );
        }

        #enfocables(region) {
          return [...region.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')].filter(
            (elemento) => !elemento.matches(':disabled, [type="hidden"], [tabindex="-1"]')
          );
        }

        #marcarOcupado(ocupado) {
          for (const region of this.#regiones('resultados')) {
            if (ocupado) region.setAttribute('aria-busy', 'true');
            else region.removeAttribute('aria-busy');
          }
        }

        #recordarFoco(enfocado) {
          const region = enfocado?.closest('[data-delora-region]');
          if (!region) return null;

          const nombre = region.getAttribute('data-delora-region');
          return {
            nombre,
            posicion: this.#regiones(nombre).indexOf(region),
            clave: enfocado.getAttribute('data-delora-clave'),
            indice: this.#enfocables(region).indexOf(enfocado),
          };
        }

        #restaurarFoco(enfocado, foco, respaldo) {
          if (!enfocado || enfocado === document.body) return;

          const actual = document.activeElement;
          const perdido =
            !actual || actual === document.body || !enfocado.isConnected || enfocado.matches(':disabled');
          if (!perdido) return;

          let destino = null;
          const region = foco ? this.#regiones(foco.nombre)[foco.posicion] : null;
          if (region) {
            const enfocables = this.#enfocables(region);
            destino =
              (foco.clave && enfocables.find((elemento) => elemento.getAttribute('data-delora-clave') === foco.clave)) ||
              enfocables[foco.indice] ||
              null;
          }

          (destino ?? respaldo ?? this.#regiones('resultados')[0])?.focus();
        }

        #sustituirRegiones(documento) {
          const nuevas = new Map();
          for (const region of documento.querySelectorAll('[data-delora-region]')) {
            const nombre = region.getAttribute('data-delora-region');
            if (!nuevas.has(nombre)) nuevas.set(nombre, []);
            nuevas.get(nombre).push(region);
          }

          const vistas = new Map();
          for (const region of this.#raiz.querySelectorAll('[data-delora-region]')) {
            const nombre = region.getAttribute('data-delora-region');
            const posicion = vistas.get(nombre) ?? 0;
            vistas.set(nombre, posicion + 1);

            const nueva = nuevas.get(nombre)?.[posicion];
            if (!nueva) {
              region.replaceChildren();
              continue;
            }

            const copia = document.importNode(nueva, true);
            this.#quitarSeccionDeEnlaces(copia);
            region.replaceWith(copia);
          }
        }

        #quitarSeccionDeEnlaces(region) {
          for (const enlace of region.querySelectorAll('a[href*="section_id="]')) {
            const url = new URL(enlace.getAttribute('href'), window.location.href);
            url.searchParams.delete('section_id');
            enlace.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
          }
        }

        #sincronizarFormularios(documento) {
          const conteos = new Map();
          for (const conteo of documento.querySelectorAll('[data-delora-conteo]')) {
            conteos.set(conteo.getAttribute('data-delora-conteo'), conteo.textContent);
          }

          for (const conteo of this.#raiz.querySelectorAll('[data-delora-conteo]')) {
            const texto = conteos.get(conteo.getAttribute('data-delora-conteo'));
            if (texto !== undefined) conteo.textContent = texto;
          }

          const formularios = documento.querySelectorAll('form[data-delora-filtros]');
          if (formularios.length === 0) return;

          const casillas = new Map();
          const valores = new Map();
          for (const formulario of formularios) {
            for (const campo of formulario.querySelectorAll('input[name], select[name]')) {
              if (campo.type === 'checkbox') casillas.set(`${campo.name}\n${campo.value}`, campo);
              else if (campo.type === 'number' || campo.tagName === 'SELECT') valores.set(campo.name, campo.value);
            }
          }

          for (const formulario of this.#raiz.querySelectorAll('form[data-delora-filtros]')) {
            for (const campo of formulario.querySelectorAll('input[name], select[name]')) {
              if (campo.type === 'checkbox') {
                const nueva = casillas.get(`${campo.name}\n${campo.value}`);
                campo.checked = nueva?.checked ?? false;
                if (nueva) campo.disabled = nueva.disabled;
                continue;
              }

              if (campo.type !== 'number' && campo.tagName !== 'SELECT') continue;
              if (!valores.has(campo.name)) continue;
              if (campo.type === 'number' && campo === document.activeElement) continue;
              campo.value = valores.get(campo.name);
            }
          }
        }

        #anunciar() {
          const resultado = this.#raiz.querySelector('[data-delora-resultados-texto]');
          const texto = resultado?.textContent.replace(/\s+/g, ' ').trim() ?? '';
          for (const estado of this.#raiz.querySelectorAll('[data-delora-estado]')) {
            estado.textContent = texto;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
